export * from './app-suppliersidebar-nav.component';



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/components/app-suppliersidebar-nav/index.ts